<template>
  <page-listado>
    <page-header title="Divisas">
      <b-button variant="primary" size="sm" to="/divisas/crear">
        <v-icon name="plus" width="16" />
        Crear divisa
      </b-button>
    </page-header>
    <tabla-divisas />
  </page-listado>
</template>

<script>
import TablaDivisas from "./TablaDivisas.vue";
export default {
  components: { TablaDivisas },
};
</script>
